import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="scale(0.75 0.75)">
    <rect width="32" height="32" rx="4" fill={fill} />
    <path
      d="M9.72852 23.5127L6.13965 8.48047H9.24658L11.5127 18.8062L14.2607 8.48047H17.8701L20.5054 18.9805L22.8125 8.48047H25.8682L22.2178 23.5127H18.998L16.0039 12.2744L13.02 23.5127H9.72852Z"
      fill="white"
    />
  </g>
);

export default Icon;
